remitRegisterModule.factory("remit", function() {

    var remit = function () {
        this.dealerRemitRegisterId = '';
        this.providerRemitCategoryId = '';
        this.startDate = '';
        this.endDate = '';
        this.closeDate = '';
        this.isSpp = '';
        this.remitRegisterXML = '';
        // What is backingData and why do we need it?
        // basically, the backing data is the data as we get it from the database - the current database implementation
        // does not update intelligently, it just overwrites everything in there with whatever you pass in, so
        // you have to make sure to pass it back all the same data it gave you, except for the values that
        // changed.
        this.backingData = null;

    };

    remit.prototype.convertForIdentityManagement = function() {
        var remittanceData;
        if(this.backingData) {
            // if we have backingData, that means we retrieved this object from the database. The backingData is already
            // in the correct format for sending it back to the db, so we don't need to create a new object - just
            // update the backingData itself
            this.backingData.dealerRemitRegisterId = this.dealerRemitRegisterId;
            this.backingData.providerRemitCategoryId = this.providerRemitCategoryId;
            this.backingData.startDate = this.startDate;
            this.backingData.endDate = this.endDate;
            this.backingData.closeDate = this.closeDate;
            this.backingData.isSpp = this.isSpp;
            this.backingData.remitRegisterXML = this.remitRegisterXML;

            remittanceData = this.backingData;
        } else {
            remittanceData = {
                dealerRemitRegisterId: this.dealerRemitRegisterId,
                providerRemitCategoryId: this.providerRemitCategoryId,
                startDate: this.startDate,
                endDate: this.endDate,
                closeDate: this.closeDate,
                isSpp: this.isSpp,
                remitRegisterXML: this.remitRegisterXML
            };
        };

        return remittanceData;
    };

    remit.prototype.populateDataFromIdentityManagement = function(data, callback) {
        var errorMessage = '';
        this.dealerRemitRegisterId = data.dealerRemitRegisterId;
        this.providerRemitCategoryId = data.providerRemitCategoryId;
        this.startDate = data.startDate;
        this.endDate = data.endDate;
        this.closeDate = data.closeDate;
        this.isSpp = data.isSpp;
        this.remitRegisterXML = data.remitRegisterXML;
        this.backingData = data;

        callback(errorMessage, this);
    };

    return remit;
});